import { Loader2 } from "lucide-react";
import { inFunctionRegion } from "@/lib/function-region";
import { useRecordingLink } from "@/services/call.query";

/**
 * A recording on one of the customer's own Twilio numbers. Twilio keeps it behind that account's password, so it
 * plays through twilio-recording-proxy, from a link the proxy hands a member of the call's workspace: an
 * <audio src> cannot send the session itself.
 */
export function TwilioRecording({ callId }: { callId: string }) {
  const { data: link, error } = useRecordingLink(callId);

  if (error) return <p className="text-sm text-muted-foreground">{error.message}</p>;
  if (!link) return <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" aria-label="Loading the recording" />;
  return (
    <audio controls className="w-full h-8" src={inFunctionRegion(link.url)}>
      Your browser does not support the audio element.
    </audio>
  );
}
